import { render, staticRenderFns } from "./BatchTable.vue?vue&type=template&id=0606636e&scoped=true&"
import script from "./BatchTable.vue?vue&type=script&lang=js&"
export * from "./BatchTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchTable.vue?vue&type=style&index=0&id=0606636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606636e",
  null
  
)

export default component.exports